/**
 * Academia — dados MOCK/temporários, separados para troca futura por API.
 *
 * - LEARNING_PATHS: trilhas de aprendizado. Hoje não existe tabela de trilhas
 *   no backend; quando existir (ex.: academia_trilhas), basta trocar este
 *   arquivo por um fetch e manter o mesmo shape.
 * - Os cursos de cada trilha são RESOLVIDOS em runtime contra o catálogo REAL
 *   (academia_items tipo=curso) via courseMatch — nada de conteúdo falso
 *   misturado com o real.
 * - MOCK_PREVIEW_COURSES: usados SOMENTE quando o catálogo real está vazio,
 *   para o owner visualizar o design enquanto sobe o conteúdo. Carregam a
 *   flag __mock e nunca abrem player.
 *
 * Shape de referência (futuro contrato de API):
 *   LearningPath { id, title, description, level, steps[], courseMatch[] }
 *   Course       { id, titulo, descricao, thumbnail_url, categoria, nivel,
 *                  duracao_estimada, total_aulas, tags[], destaque }
 */

export const LEARNING_PATHS = [
  {
    id: 'path-zero-ao-canal',
    title: 'Do Zero ao Primeiro Canal Monetizado',
    description: 'A sequência completa: nicho, canal, produção e monetização.',
    level: 'iniciante',
    steps: [
      'Fundamentos de canais dark',
      'Nicho e idioma com o Niche Finder',
      'Produção: roteiro, áudio e SRT',
      'Publicação e rotina de análise',
      'Caminho até a monetização',
    ],
    // Palavras que casam título/categoria/tags dos cursos REAIS do catálogo
    courseMatch: ['zero', 'canal', 'fundament', 'monetiz', 'nicho'],
  },
  {
    id: 'path-automacao-veo',
    title: 'Automação VEO de Ponta a Ponta',
    description: 'Do prompt ao vídeo renderizado: o fluxo VEO sem fricção.',
    level: 'intermediario',
    steps: [
      'Estrutura de prompts para VEO',
      'SRT como roteiro de cena',
      'Lote: gerar, revisar, montar',
      'Qualidade e consistência visual',
    ],
    courseMatch: ['veo', 'automa', 'srt'],
  },
  {
    id: 'path-fabrica-prompts',
    title: 'Fábrica de Prompts e Skills',
    description: 'Prompts que rendem: biblioteca própria, skills e reuso.',
    level: 'intermediario',
    steps: [
      'Anatomia de um prompt que converte',
      'Skills e templates reutilizáveis',
      'Extensão e ferramentas no fluxo',
    ],
    courseMatch: ['prompt', 'skill', 'template', 'extens'],
  },
];

/**
 * Resolve os cursos reais de uma trilha por correspondência de
 * título/categoria/tags (case-insensitive). Trilha sem cursos publicados
 * ainda aparece (com as etapas), marcada como "em breve".
 */
export function matchPathCourses(path, cursos) {
  if (!Array.isArray(cursos) || cursos.length === 0) return [];
  const terms = path.courseMatch.map((s) => s.toLowerCase());
  return cursos.filter((c) => {
    const hay = [c.titulo, c.categoria, ...(c.tags || [])]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return terms.some((term) => hay.includes(term));
  });
}

/**
 * Preview de catálogo vazio: cursos ilustrativos com temas reais do
 * DarkPlanner. Exibidos APENAS quando a API devolve zero cursos, com selo
 * "Exemplo" — clique não abre player.
 */
export const MOCK_PREVIEW_COURSES = [
  {
    id: 'mock-canal-dark',
    __mock: true,
    tipo: 'curso',
    titulo: 'Canais Dark: do nicho ao primeiro upload',
    descricao: 'Escolha de nicho com dados, identidade do canal e o primeiro vídeo no ar.',
    categoria: 'Canais Dark',
    nivel: 'iniciante',
    total_aulas: 8,
    duracao_estimada: '2h 10min',
    tags: ['canal', 'nicho'],
    likes_count: 0,
    views_count: 0,
  },
  {
    id: 'mock-veo',
    __mock: true,
    tipo: 'curso',
    titulo: 'Automação VEO na prática',
    descricao: 'Prompt, SRT e lote: o pipeline de vídeo automatizado de ponta a ponta.',
    categoria: 'Automação',
    nivel: 'intermediario',
    total_aulas: 6,
    duracao_estimada: '1h 45min',
    tags: ['veo', 'automacao'],
    likes_count: 0,
    views_count: 0,
  },
  {
    id: 'mock-prompts',
    __mock: true,
    tipo: 'curso',
    titulo: 'Prompts e Skills que escalam',
    descricao: 'Construa sua biblioteca de prompts, skills e templates reutilizáveis.',
    categoria: 'Prompts',
    nivel: 'intermediario',
    total_aulas: 5,
    duracao_estimada: '1h 20min',
    tags: ['prompt', 'skill'],
    likes_count: 0,
    views_count: 0,
  },
  {
    id: 'mock-monetizacao',
    __mock: true,
    tipo: 'curso',
    titulo: 'Monetização: requisitos e aceleração',
    descricao: 'O caminho realista até a monetização e como encurtá-lo com método.',
    categoria: 'Monetização',
    nivel: 'avancado',
    total_aulas: 7,
    duracao_estimada: '2h 30min',
    tags: ['monetizacao'],
    likes_count: 0,
    views_count: 0,
  },
];

